!function() {
  var t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {}, e = {}, i = {}, o = t.parcelRequire5f74;
  null == o && ((o = function(t) {
    if (t in e) return e[t].exports;
    if (t in i) {
      var o = i[t];
      delete i[t];
      var n = {
        id: t,
        exports: {}
      };
      return e[t] = n, o.call(n.exports, n, n.exports), n.exports;
    }
    var l = new Error("Cannot find module '" + t + "'");
    throw l.code = "MODULE_NOT_FOUND", l;
  }).register = function(t, e) {
    i[t] = e;
  }, t.parcelRequire5f74 = o), (0, o.register)("82gMS", function(t, e) {
    var i, o, n, l;
    function s(t, e) {
      let i, o;
      const n = (...n) => {
        o ? (clearTimeout(i), i = setTimeout(() => {
          Date.now() - o >= e && (t(...n), o = Date.now());
        }, e - (Date.now() - o))) : (t(...n), o = Date.now());
      };
      return n.cancel = () => {
        clearTimeout(i), i = null, o = null;
      }, n;
    }
    i = t.exports, o = "throttle", n = function() {
      return s;
    }, Object.defineProperty(i, o, {
      get: n,
      set: l,
      enumerable: !0,
      configurable: !0
    });
  });
  var n = o("82gMS");
  customElements.get("sticky-footer") || customElements.define("sticky-footer", class extends HTMLElement {
    constructor() {
      super(), this.tabletMQ = null, this.isNearBottomState = null, this.logoVisibilityState = null, 
      this.footer = this.closest("footer.section.section--footer"), this.mainEl = document.querySelector("main"), 
      this.largeLogoEl = this.querySelector(".footer__large-logo"), this.handleScroll = (0, 
      n.throttle)(this.handleScroll.bind(this), 100);
    }
    handleScroll(t) {
      const e = window.scrollY + window.innerHeight, i = document.documentElement.scrollHeight - e < 2 * window.innerHeight;
      if (this.isNearBottomState !== i && (this.isNearBottomState = i, this.footer.classList.toggle("section--sticky", i && this.mainEl.offsetHeight > window.innerHeight)), 
      this.mainEl && this.largeLogoEl) {
        const t = this.mainEl.offsetHeight > window.innerHeight ? this.mainEl.getBoundingClientRect().bottom < this.largeLogoEl.getBoundingClientRect().top && i : window.scrollY + window.innerHeight >= this.largeLogoEl.getBoundingClientRect().bottom;
        this.logoVisibilityState !== t && (this.logoVisibilityState = t, window.dispatchEvent(new CustomEvent("footer-logo-display", {
          bubbles: !0,
          detail: {
            visible: t
          }
        })));
      } else null !== this.logoVisibilityState && (this.logoVisibilityState = null);
    }
    connectedCallback() {
      this.footer && (this.tabletMQ = window.matchMedia("(max-width: 1024px)"), this.tabletMQ.matches || window.addEventListener("scroll", this.handleScroll, {
        passive: !0
      }), this.tabletMQ.addEventListener("change", t => {
        t.matches ? window.removeEventListener("scroll", this.handleScroll) : window.addEventListener("scroll", this.handleScroll, {
          passive: !0
        });
      }));
    }
    disconnectedCallback() {
      window.removeEventListener("scroll", this.handleScroll);
    }
  });
}();